import { render, staticRenderFns } from "./review-failed.vue?vue&type=template&id=f64a950a&"
import script from "./review-failed.vue?vue&type=script&lang=js&"
export * from "./review-failed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports